<template>
<div class="content">
    <div class="content_wrap">
            <h2 class="content_title">Quiz</h2>
    <div class="quiz_wrap">
        <h3 class="qtitle">
            <span class="qunum">Q{{order + 1}}.</span>
            <div v-html="quiz.question" class="shortque"></div>
            </h3>
            <div class="textquiz_wrap clearfix">
                <form v-on:submit.prevent="pickAnswer" class="txtquiz">
                    <p class="txt_answer">A : </p>
                    <input placeholder="정답을 입력해주세요." v-model="user_input" type="text" class="textanswer">
                    <a @click="pickAnswer()" href="#" class="txt_btn">입력</a>
                </form>
            </div>
            <transition name="fade">
                <div v-show="explain == 'true'" class="resultbox right">
                    <div class="re_right">
                        <p class="answerbox correct">정답</p>
                        <span class="commtxt">정답 : <span class="bold">{{quiz.answer}}</span></span>
                        <p class="answerbox comment">해설</p>
                        <span class="commtxt" v-html="quiz.explain"></span>
                    </div>
                    <div class="clearfix">
                        <a @click="goQuizNext(order + 1)" class="quizbt float_right main">다음</a>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div v-show="explain == 'false'" class="resultbox wrong">
                    <div class="re_right">
                        <p class="answerbox wrong">오답</p>
                        <span class="commtxt">정답 : <span class="bold">{{quiz.answer}}</span></span>
                        <p class="answerbox comment">해설</p>
                        <span class="commtxt" v-html="quiz.explain"></span>
                    </div>
                    <div class="clearfix">
                        <a @click="goQuizNext(order + 1)" class="quizbt float_right main">다음</a>
                    </div>
                </div>
            </transition>
                <div v-show="tryAnswer == 1 && explain == null" class="resultbox chance">
                    <p class="wrtxt">
                        틀렸습니다. 다시 시도해주세요.
                    </p>
                </div>
        </div>
    </div>
</div>
</template>
<script>
import {pad} from '../../helpers'
export default {
    props : ['quiz','order','currentSlide'],
    data(){
        return{
            tryAnswer : 0, 
            user_input: '',
            explain : null,
            pickedAnswer : null,
            correctSound : new Audio("../assets/media/correct_answer.mp3"),
            wrongSound : new Audio("../assets/media/incorrect.mp3"),
        }
    },
    methods:{
        pickAnswer(){
            if(this.tryAnswer > 1){
                this.tryAnswer = 2;
                swal('알림','다음 문제를 풀어주세요.','info');
                return;
            }
            if(this.user_input.length < 2){
                swal('알림','답변란에 답변을 해주세요.','info');
                return;
            }
            
            if(this.user_input.trim() == this.quiz.answer){//crrect answer
                this.explain = 'true';
                this.$emit('answered',this.order,'correct');
                this.tryAnswer = 2;
                this.correctSound.play();
            }else if(this.tryAnswer == 0){//first tryAnswer failed

            }else{
                this.explain = 'false';
                this.$emit('answered',this.order,'wrong');
                this.wrongSound.play();
            }
            this.tryAnswer++;
            // this.pickedAnswer = this.user_input;
        },
        goQuizNext(value){
            this.$emit('goQuizNext',value);
            this.tryAnswer = 0;
        },
    },
    mounted(){
    }
}
</script>